import Link from 'next/link';
import React from 'react';
import { cn } from '../../../../../utils/tailwind/cn';
import CatIcon from '../../../assets/cat-icon.svg';
import { useFiltersStore } from '@/containers/BookingJourney/context';
export const OvernightLinks = () => {
  const service = useFiltersStore(state => state.filters.service);

  // Define service link configurations
  const serviceLinks = {
    boarding: {
      text: 'For overnight care at your home,',
      linkText: 'try Sitting with Wag!',
      href: '/dog-sitting',
      ariaLabel: 'Dog Sitting'
    },
    sitting: {
      text: 'For overnight care at Caregiver\'s home,',
      linkText: 'try Boarding with Wag!',
      href: '/dog-boarding',
      ariaLabel: 'Dog Boarding'
    }
  };

  // Get the link config for the current service
  const linkConfig = serviceLinks[service as keyof typeof serviceLinks];

  // Return null if we don't have a config for this service
  if (!linkConfig) return null;
  return <p className="text-center" data-sentry-component="OvernightLinks" data-sentry-source-file="links.tsx">
      {linkConfig.text}
      <br className="md:hidden" />
      <Link aria-label={linkConfig.ariaLabel} href={linkConfig.href} className="ml-[2px] underline pl-1" data-sentry-element="Link" data-sentry-source-file="links.tsx">
        {linkConfig.linkText}
      </Link>
    </p>;
};
export const CatLinks = () => <div className="flex items-center justify-center" data-sentry-component="CatLinks" data-sentry-source-file="links.tsx">
    <div className="p-2 w-fit bg-caribbeanGreen rounded-full mr-2">
      <img src={CatIcon} alt="Cat Icon" className={cn('w-[26px] h-[26px] mx-auto')} />
    </div>
    <Link aria-label="Cat Sitting" href="/cat-sitting" className="text-caribbeanGreen font-[600] underline ml-4" data-sentry-element="Link" data-sentry-source-file="links.tsx">
      Cat Sitting
    </Link>
  </div>;
export const PetWalkingLinks = () => <p className="text-center" data-sentry-component="PetWalkingLinks" data-sentry-source-file="links.tsx">
    Looking for a caregiver to take your pet for a walk? 
    <br className="md:hidden" />
    <Link aria-label="Cat Sitting" href="/dog-walking" className="ml-[2px] underline" data-sentry-element="Link" data-sentry-source-file="links.tsx">
      Pet Walking services are available
    </Link>
  </p>;